module.exports = {
    siteTitle: 'Daisy Macharia| Software Engineer',
    siteDescription:
        'Daisy Macharia is a software engineer based in Nairobi Kenya',
    siteKeywords:
        'Daisy Macharia, Daisy, javascript, software engineer, front-end engineer, web developer',

    navLinks: [
        // {
        //     name: 'About',
        //     url: '#about',
        // },
        {
            name: 'Experience',
            url: '#jobs',
            page: '01'
        },
        {
            name: 'Projects',
            url: '#projects',
            page: '02'
        },
        // {
        //     name: 'My Digital Garden',
        //     url: '#contact',
        //     page: '03'
        // },
    ],

}
